import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ShieldCheck } from 'lucide-react';

const LOAN_TYPES = [
  { value: 'housing-loan', label: 'Home Loan' },
  { value: 'education-loan', label: 'Education Loan' },
  { value: 'car-loan', label: 'Car Loan' },
  { value: 'property-mortgage', label: 'Loan Against Property' },
  { value: 'sme-loan', label: 'SME / Business Loan' },
  { value: 'corporate-loan', label: 'Corporate Loan' },
  { value: 'gold-loan', label: 'Gold Loan' },
];

export const LeadMagnetForm = ({ values, onChange, onSubmit, isSubmitting }) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <div className="space-y-2">
      <Label htmlFor="lead-name">Your Name *</Label>
      <Input
        id="lead-name"
        placeholder="Enter your full name"
        value={values.name}
        onChange={(e) => onChange('name', e.target.value)}
        data-testid="lead-popup-name-input"
      />
    </div>
    <div className="space-y-2">
      <Label htmlFor="lead-phone">Phone Number *</Label>
      <Input
        id="lead-phone"
        type="tel"
        placeholder="+91 98765 43210"
        value={values.phone}
        onChange={(e) => onChange('phone', e.target.value)}
        data-testid="lead-popup-phone-input"
      />
    </div>
    <div className="space-y-2">
      <Label>Loan Type *</Label>
      <Select value={values.loanType} onValueChange={(v) => onChange('loanType', v)}>
        <SelectTrigger data-testid="lead-popup-loan-select">
          <SelectValue placeholder="Select loan type" />
        </SelectTrigger>
        <SelectContent>
          {LOAN_TYPES.map(({ value, label }) => (
            <SelectItem key={value} value={value}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <Button
      type="submit"
      disabled={isSubmitting}
      className="w-full bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white"
      data-testid="lead-popup-submit-btn"
    >
      {isSubmitting ? 'Checking...' : 'Check My Eligibility — Free'}
    </Button>
    <p className="flex items-center justify-center gap-1.5 text-xs text-gray-500">
      <ShieldCheck className="w-3.5 h-3.5 text-teal-600" />
      Your details are safe. No spam, ever.
    </p>
  </form>
);

export default LeadMagnetForm;
